import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]

  submitWithContent(event) {
    event.preventDefault()
    console.log(this.contentTarget)
    const clickedButton = event.currentTarget
    const content = clickedButton.dataset.content
    this.contentTarget.value = content
    this.element.requestSubmit()
  }
}
